import { twMerge } from "tailwind-merge";
import clsx from "clsx";

const cn = (...inputs) => twMerge(clsx(inputs));

export const ConnectorLine = ({ className = "" }) => {
  return (
    <div className="w-full flex justify-center">
      <div
        className={cn(
          "w-px h-6 border-l border-dashed border-gray-400 dark:border-gray-500",
          className,
        )}
      />
    </div>
  );
};
